module.exports = __webpack_public_path__ + "static/media/traits-header.9cbdcfb7.png";